


































import Vue from "vue"
export default Vue.extend({
  name: 'notificationconfirm',
  props: {
    isvisible: Boolean,
    title: String,
    message: String
  },
 computed:{
    is_visible:{
      get(): boolean {
        return (this as any).isvisible
      },
      set(v: any){
        (this as any).$emit("evtclose",v)
      }
    }
  },
  methods:{
    action(type){
      this.$emit("evtoption",type)
    }
  }
})
